import type { ReactNode } from 'react';
import { Maximize2, Minus, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Explorer, type ExplorerProps } from './Explorer';

/**
 * Window frame for OS pages. Opens full-stage (flush under the menu bar, no radius) so it reads as a web app
 * with desktop launch behaviour. Close/minimise return to the launcher; the green light toggles a framed
 * "restored" size that shows the wallpaper around it and the dock below (state owned by `Desktop`, which shows the dock).
 * The body is an Explorer navigation pane + scrolling main.
 */
export function Window({ title, explorer, max, onMaxChange, children }: { title: string; explorer: ExplorerProps; max: boolean; onMaxChange: (max: boolean) => void; children: ReactNode }) {
  const nav = useNavigate();
  const setMax = (f: (m: boolean) => boolean) => onMaxChange(f(max));
  return (
    <section className="win" data-max={max ? '1' : '0'} aria-label={title}>
      <div className="win-bar" onDoubleClick={() => setMax((m) => !m)}>
        <div className="win-lights">
          <button type="button" className="win-close" aria-label="Close" onClick={() => nav('/')}><X strokeWidth={3} /></button>
          <button type="button" className="win-min" aria-label="Minimise" onClick={() => nav('/')}><Minus strokeWidth={3} /></button>
          <button type="button" className="win-max" aria-label={max ? 'Restore' : 'Maximise'} onClick={() => setMax((m) => !m)}><Maximize2 strokeWidth={3} /></button>
        </div>
        <div className="win-title">{title}</div>
        <div />
      </div>
      <div className="win-body">
        <Explorer {...explorer} />
        <div className="win-main">{children}</div>
      </div>
    </section>
  );
}
